import React, { Component } from 'react'
import { observer } from 'mobx-react'
import i18n from 'i18next'
import * as R from 'ramda'
import Modal from '../../../../UniformComponents/Modal'
import Button from '../../../../UniformComponents/Button'
import ModalFooter from '../../../../UniformComponents/ModalFooter'
import Select from '../../../form/Select'
import Input from '../../../form/Input'

@observer
class BenchmarkTestModal extends Component {
    constructor(props) {
        super(props)
        this.state = {
            questionId: undefined,
            productType: undefined,
            surveyType: undefined,
            respondentType: undefined,
            tagOptionId: undefined,
            testResults: [],
        }
    }

    runTest = async () => {
        const { store } = this.props
        const { testBenchmark, store: appStore, customTag } = store
        const { industry } = customTag
        const {
            productType, surveyType, respondentType, questionId, tagOptionId,
        } = this.state

        const body = {
            period: 84,
            tagOptionId: typeof testBenchmark === 'number' ? testBenchmark : tagOptionId,
            industry,
            productType,
            surveyType,
            respondentType,
            questionId,
        }
        const responses = await Promise.all([
            appStore.http.post('/intranet/benchmarking/rules/test', JSON.stringify(body)),
            appStore.http.post('/intranet/benchmarking/rules/test', JSON.stringify({ ...body, period: 36 })),
        ])
        this.setState({ testResults: responses })
    }

    renderTagOptionPicker = () => {
        const { store } = this.props
        const { testBenchmark, tagList, customTag } = store
        if (typeof testBenchmark === 'number') return null
        const benchmarkTag = R.pathOr(undefined, ['config', 'benchmarkRules', 0, 'config', 'tagId'], customTag)
        const tagOptions = R.pathOr([], ['config', 'answerOptions'], tagList.find((tag) => tag.id === benchmarkTag))
        return (
            <div>
                <Select
                    label={i18n.t('customTag.testBenchmarks.benchmark')}
                    options={tagOptions.map((to) => (
                        { label: to.config.langs.en_GB, value: to.id }
                    ))}
                />
            </div>
        )
    }

    renderTestResults = () => {
        const { testResults } = this.state

        return (
            <div className="testResultsContainer" style={{ display: 'flex', gap: '100px' }}>
                {testResults.map((testResult) => {
                    const {
                        rules, clientRepresentationResult, sampleSize,
                    } = testResult
                    return (
                        <div className="testResults" style={{ marginTop: '15px' }}>
                            <div className="mustHave" style={{ marginBottom: '10px' }}>
                                <p style={{ fontSize: '16px', fontWeight: 'bold', marginBottom: '5px' }}>
                                    {i18n.t('customTag.testBenchmarks.resultsTitle')}
                                    {rules.period}
                                </p>
                                <p>
                                    {i18n.t('customTag.testBenchmarks.minQuestionBaseline')}
                                    {rules.questionBaseLine}
                                </p>
                                <p>
                                    {i18n.t('customTag.testBenchmarks.clientRepresentation')}
                                    {rules.clientRepresentation}
                                </p>
                                <p>
                                    {i18n.t('customTag.testBenchmarks.minSurveyWeight')}
                                    {rules.surveyWeight}
                                </p>
                                <p>
                                    {i18n.t('customTag.testBenchmarks.minSurveyBaseline')}
                                    {rules.surveyBaseLine}
                                </p>
                                <p>
                                    {i18n.t('customTag.testBenchmarks.minClients')}
                                    {rules.contributingClients}
                                </p>
                            </div>
                            <div className="benchmarkHas">
                                <p style={{ fontSize: '16px', fontWeight: 'bold', marginBottom: '5px' }}>
                                    {i18n.t('customTag.testBenchmarks.benchmarkHas')}
                                </p>
                                <p>
                                    {i18n.t('customTag.testBenchmarks.clientRepresentation')}
                                    {
                                        Math.max(...clientRepresentationResult
                                            .map((cr) => cr.weightedContribution))
                                    }
                                </p>
                                <p>
                                    {i18n.t('customTag.testBenchmarks.surveySample')}
                                    {sampleSize}
                                </p>
                                <p>
                                    {i18n.t('customTag.testBenchmarks.numClients')}
                                    {clientRepresentationResult.length}
                                </p>
                            </div>
                        </div>
                    )
                })}

            </div>
        )
    }

    closeModal = () => {
        const { store } = this.props
        const { toggleTestBenchmark } = store

        this.setState({
            questionId: undefined,
            productType: undefined,
            surveyType: undefined,
            respondentType: undefined,
            tagOptionId: undefined,
            testResults: [],
        })
        toggleTestBenchmark()
    }

    render() {
        const { store } = this.props
        const {
            testBenchmark,
            productMap,
            customTag,
        } = store
        const { industry } = customTag
        const { productType, surveyType } = this.state

        const productTypes = Object.values(R.pathOr({}, [industry, 'children'], productMap))
        const surveyTypes = Object.values(R.pathOr({}, [industry, 'children', productType, 'children'], productMap))
        const respondentTypes = Object.values(R.pathOr(
            {},
            [industry, 'children', productType, 'children', surveyType, 'children'],
            productMap,
        ))

        return (
            <Modal
                show={testBenchmark}
                onClose={this.closeModal}
                cssClass="benchmarksModal"
            >
                <div className="body">
                    <div className="settings" style={{ width: '100%' }}>
                        <div className="typeOptions" style={{ display: 'flex', gap: '10px', width: '100%' }}>
                            <Select
                                label={i18n.t('product_type')}
                                options={productTypes}
                                onBlur={({ value }) => this.setState({ productType: value })}
                                blurInputOnSelect
                            />
                            <Select
                                label={i18n.t('survey_type')}
                                options={surveyTypes}
                                onBlur={({ value }) => this.setState({ surveyType: value })}
                                blurInputOnSelect
                            />
                            <Select
                                label={i18n.t('respondent_type')}
                                options={respondentTypes}
                                onBlur={({ value }) => this.setState({ respondentType: value })}
                                blurInputOnSelect
                            />
                        </div>
                        <div className="questionOption" style={{ width: '300px' }}>
                            <Input
                                label={i18n.t('customTag.testBenchmarks.questionId')}
                                onBlur={({ value }) => this.setState({ questionId: value })}
                            />
                        </div>
                        <div className="questionOption" style={{ width: '300px' }}>
                            {this.renderTagOptionPicker()}
                        </div>
                        <div>
                            {this.renderTestResults()}
                        </div>
                    </div>
                </div>
                <ModalFooter>
                    <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                        <Button
                            label={i18n.t('close')}
                            cssClass="tertiary regular"
                            style={{
                                width: '134px', fontWeight: 600, textAlign: 'center',
                            }}
                            onClick={this.closeModal}
                        />
                        <Button
                            label={i18n.t('customTag.testBenchmarks.runTest')}
                            cssClass="tertiary regular"
                            style={{
                                width: '134px', fontWeight: 600, textAlign: 'center',
                            }}
                            onClick={this.runTest}
                        />
                    </div>
                </ModalFooter>
            </Modal>
        )
    }
}

export default BenchmarkTestModal
